import type {GlossyBsdfNode} from "#material/cycles/types"
import type {Distribution} from "#material/nodes/shader/bsdf-glossy/types"
import {Three as THREE} from "#material/three/exports"

export const getDefaultMaterial = () => new THREE.MeshPhysicalNodeMaterial()

export const cyclesDistribution = (distribution?: Distribution): GlossyBsdfNode["parameters"]["distribution"] => {
    if (!distribution) {
        return undefined
    }
    switch (distribution) {
        case "BECKMANN":
            return "beckmann"
        case "ASHIKHMIN_SHIRLEY":
            return "ashikhmin_shirley"
        case "GGX":
            return "ggx"
        case "MULTI_GGX":
            return "multi_ggx"
    }
}
